<style scoped>
.radius {
  border-radius: 0.25rem;
}
</style>
<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus'

export default {
  name: 'CardList',
  props: {
    alertInfo: {
      type: Boolean,
      value: false
    }
  },

  data () {
    return {
      selectedCardIndex: null
    }
  },

  computed: {
    ...mapGetters(['merchantSavedCards'])
  },

  methods: {
    generateMaskedNumber (lastFourDigits) {
      const maskedDigits = '\u2022'.repeat(12)
      return maskedDigits + lastFourDigits
    },

    addNewCard () {
      EventBus.$emit('addCard', true)
      this.$store.commit('setEnableNTSFlow', true)
    }
  }
}
</script>
<template>
  <div
    id="card-payment-info"
    class="card-item mx-1">
    <template v-if="merchantSavedCards.length > 0">
      <div class="d-flex justify-content-between py-3 px-2">
        <h4>{{ $t("label.saveCard") }}</h4>
        <a
          class="cursor-pointer"
          @click="addNewCard"
        >
          <i class="fa fa-plus-circle fa-2x " />
        </a>
      </div>
      <div
        v-if = "alertInfo"
        class="alert alert-success px-2 mx-1"
        role="alert">
        <i class="fa fa-check-circle fa-lg mr-2" />
        {{ $t("label.savedCardMessage") }}
      </div>
      <div
        v-for="(card, key) in merchantSavedCards"
        :key="key"
        class="d-flex align-items-center justify-content-between border border-grey p-3 mb-3 radius mx-1"
      >
        <div>
          <label
            :for="'card-' + key"
            class="align-items-center d-flex mb-0 pb-0">
            <div class="d-flex gap-2">
              <div>
                <img
                  :src="card.scofMaskedCard.digitalCardData.artUri"
                  alt="No Image"
                  class="img-thumbnail card-logo"
                >
              </div>
              <div class="card-details">
                <div data-test="card-number">
                  {{ card.scofMaskedCard.digitalCardData.descriptorName }}
                </div>
                <div class="card-holder">
                  {{ generateMaskedNumber(card.scofMaskedCard.panLastFour) }}
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        role="alert"
        class="alert alert-info d-flex align-items-center justify-content-between">
        {{ $t("label.noSavedCard") }}
        <a
          class="cursor-pointer"
          @click="addNewCard"
        > {{ $t("label.addNewCard") }}</a>
      </div>
    </template>
  </div>
</template>
